<template>
  <div>
    <v-card-actions>
      <v-spacer />
      <v-btn
        button-full
        size="large"
        @click="anotherTask()"
      >
        Ok
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'TicketActions',

  methods: {

    ...mapActions('ticket', ['actionButtonsMenuToSideBar']),

    anotherTask() {
      this.paymentModal = false;
      this.actionButtonsMenuToSideBar({
        routerViewCol: 12,
        sidebar: 0,
        sidebarDisplay: 'd-none',
      });
      this.$router.push({
        name: 'ticket-show',
        params: {
          id: this.$route.params.id,
        },
      });
    },
  },
};
</script>
